import Container from "react-bootstrap/Container";
import catImg from "url:./logo-mid-r.webp";
import { Menu } from "./Menu.js";
import { Outlet } from "react-router-dom";
export const App = () => {
  return (
    <div>
      <Container>
        <Menu />
        <div id="body-container">
          <img id="body-img" src={catImg} />
          {/* <div id="body-text">
            <h1>
              <Donate />
            </h1>
            <span id="donate-subheader-text">
              Please support our animal rescue organization and help us provide care and shelter for animals in need.
            </span>
          </div> */}
        </div>
        <div id="main">
          <Outlet />
        </div>
      </Container>
    </div>
  );
};
